import { get, head } from 'lodash-es';

/**
 * Determines if there was price drop using current and original prices
 * @param {object} vinData
 * @returns {{
 *   priceChange: number,
 *   isPriceDrop: boolean,
 *   currentPrice: number,
 *   originalPrice: number,
 *   history: Array<{amount: number, timestamp: number}>
 * }}
 */
export function getPriceChange({ vinData }) {
  const currentPrice = get(vinData, 'prices.advertisedPrice', 0);

  const history = get(vinData, 'computedDisplayInfo.priceHistoryInfo.historicalPrices', []);
  const originalPrice = get(head(history), 'amount', 0);
  const historyLength = history.length;
  const isLatestPriceIncrease = !!history.length && currentPrice > get(history[historyLength - 1], 'amount', 0);

  const isPriceDrop = !!currentPrice && !!originalPrice && currentPrice < originalPrice && !isLatestPriceIncrease;
  const priceChange = Math.abs(currentPrice - originalPrice);

  return {
    isPriceDrop,
    priceChange,
    currentPrice,
    originalPrice,
    history,
  };
}
